import type { ReactNode } from 'react'
import { AppStatusState } from './AppStatusState'

export interface AppLoadingStateProps {
  readonly className?: string
  readonly message?: ReactNode
  readonly minHeight?: number | string
  readonly title?: ReactNode
}

export function AppLoadingState({
  className,
  message = 'Keep this page open while we prepare the next content.',
  minHeight = 184,
  title = 'Loading',
}: AppLoadingStateProps) {
  return (
    <AppStatusState
      className={className ? `appLoadingState ${className}` : 'appLoadingState'}
      isLoading
      message={message}
      minHeight={minHeight}
      title={title}
      tone="loading"
    />
  )
}

